/* 1200px以下でviewport変更 */
(function () {
  function updateViewport() {
    let viewport = document.querySelector("meta[name=viewport]");
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.head.appendChild(viewport);
    }

    if (screen.width <= 1200 && screen.width >= 680) {
      viewport.content = "width=1200";
    } else {
      viewport.content = "width=device-width, initial-scale=1";
    }
  }

  updateViewport();
  window.addEventListener("resize", updateViewport);
})();

/* スムーススクロール */
$(document).ready(function () {
  var headerHeight = $(".site-header").outerHeight() || 80;

  $('a[href^="#"], a[href*="#"]').click(function (e) {
    var href = $(this).attr("href");
    var targetId = href.split("#")[1];
    var target = $("#" + targetId);

    if (target.length) {
      var position = target.offset().top - headerHeight;
      $("body,html").stop().animate({
        scrollTop: position
      }, 500);
      e.preventDefault();
    }
  });

  if (window.location.hash) {
    var target = $(window.location.hash);
    if (target.length) {
      var position = target.offset().top - headerHeight;
      $("body,html").scrollTop(position);
    }
  }
});

/* フェードイン01 */
document.addEventListener("DOMContentLoaded", function () {
  const elems = document.querySelectorAll(".fadein");

  const observer = new IntersectionObserver((entries) => {
    const visible = entries
      .filter(entry => entry.isIntersecting)
      .map(entry => entry.target)
      .sort((a, b) => {
        return Array.from(elems).indexOf(a) - Array.from(elems).indexOf(b);
      });

    visible.forEach((el, i) => {
      el.classList.add("fadein_active");
      el.style.transitionDelay = `${i * 0.07}s`;
      observer.unobserve(el);
    });
  }, {
    rootMargin: "0px 0px -40px 0px",
    threshold: 0,
  });

  elems.forEach((el) => observer.observe(el));
});

/* フェードイン02 */
document.addEventListener("DOMContentLoaded", () => {
  const elems = document.querySelectorAll(".action01, .action02, .action03, .action04, .action05, .action01_sp, .action02_sp, .action03_sp, .action04_sp, .anime");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("action");
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: "0px 0px -40px 0px",
    threshold: 0,
  });

  elems.forEach(el => observer.observe(el));
});

/* ハンバーガーメニュー */
document.addEventListener("DOMContentLoaded", function () {
  const hamburger = document.getElementById('hamburger');
  const spMenu = document.getElementById('sp-menu');

  if (hamburger && spMenu) {
    hamburger.addEventListener('click', function () {
      this.classList.toggle('active');
      spMenu.classList.toggle('active');
      document.body.style.overflow = spMenu.classList.contains('active') ? 'hidden' : '';
    });

    // メニュー内のリンクをクリックしたらメニューを閉じる
    spMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function () {
        hamburger.classList.remove('active');
        spMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }
});

/* アコーディオン */
$(".sec7_item_title").on("click", function () {
  var findElm = $(this).next(".sec7_item_text");
  $(findElm).slideToggle();

  if ($(this).hasClass("close")) {
    $(this).removeClass("close");
  } else {
    $(this).addClass("close");
  }
});

/* ===================================================
   Shopify カート機能
=================================================== */

/* 数量ボタン */
document.addEventListener("DOMContentLoaded", function () {
  const minusBtn = document.querySelector(".quantity-btn.minus");
  const plusBtn = document.querySelector(".quantity-btn.plus");
  const quantityInput = document.querySelector("#quantity");

  if (minusBtn && plusBtn && quantityInput) {
    minusBtn.addEventListener("click", function () {
      let currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    plusBtn.addEventListener("click", function () {
      let currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue < 99) {
        quantityInput.value = currentValue + 1;
      }
    });

    quantityInput.addEventListener("change", function () {
      let value = parseInt(this.value) || 1;
      if (value < 1) value = 1;
      if (value > 99) value = 99;
      this.value = value;
    });
  }
});

/* カートに追加（Ajax） */
document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector('.product-form form');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitBtn = this.querySelector('.add-to-cart-btn');
      const originalText = submitBtn.textContent;

      // ボタンを無効化
      submitBtn.disabled = true;
      submitBtn.textContent = '追加中...';

      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // カート数を更新（ヘッダーにカートアイコンがある場合）
          updateCartCount();

          // ポップアップを表示
          showCartPopup();

          // ボタンを元に戻す
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        })
        .catch(error => {
          console.error('Error:', error);
          showCartNotification('エラーが発生しました', true);

          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        });
    });
  }
});

/* カート追加ポップアップ */
function showCartPopup() {
  const overlay = document.getElementById('cart-popup-overlay');
  if (overlay) {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function hideCartPopup() {
  const overlay = document.getElementById('cart-popup-overlay');
  if (overlay) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById('cart-popup-overlay');
  const closeBtn = document.getElementById('cart-popup-close');
  const continueBtn = document.getElementById('cart-popup-continue');

  if (closeBtn) {
    closeBtn.addEventListener('click', hideCartPopup);
  }

  if (continueBtn) {
    continueBtn.addEventListener('click', hideCartPopup);
  }

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        hideCartPopup();
      }
    });
  }
});

/* 通知表示 */
function showCartNotification(message, isError = false) {
  // 既存の通知を削除
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  // 新しい通知を作成
  const notification = document.createElement('div');
  notification.className = 'cart-notification';
  notification.textContent = message;

  if (isError) {
    notification.style.background = '#e74c3c';
  }

  document.body.appendChild(notification);

  // アニメーション
  setTimeout(() => {
    notification.classList.add('show');
  }, 10);

  // 3秒後に非表示
  setTimeout(() => {
    notification.classList.remove('show');
    setTimeout(() => {
      notification.remove();
    }, 300);
  }, 3000);
}

/* カート数を更新 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    });
}

/* バリアント選択時の価格更新 */
document.addEventListener("DOMContentLoaded", function () {
  const variantSelect = document.querySelector('#variant-select');

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      // バリアントIDを隠しフィールドに設定
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = this.value;
      }
    });
  }
});
